import { Button } from "@mui/material";
import { useTranslations } from "use-intl";
import { usePaymentContext } from "@/app/lib/context/PaymentContext";
import { PersistentDrawer } from "../PersistentDrawer";
import { Feature, isFeatureEnabled } from "@/app/lib/utils/featureFlags";

const BottomDrawer = ({
  totalPrice,
  buttonLabel,
  onButtonClick,
  disabled,
  loading,
  showPayLater = false,
  payLaterPrice,
}: {
  totalPrice?: string;
  payLaterPrice?: string;
  buttonLabel: string;
  onButtonClick: () => void;
  disabled: boolean;
  loading?: boolean;
  showPayLater?: boolean;
}) => {
  const t = useTranslations();
  const { paymentType, isEligible } = usePaymentContext();
  const isBnplFeatureEnabled = isFeatureEnabled(Feature.Bnpl);

  const isBnpl = paymentType === "bnpl";

  return (
    <PersistentDrawer>
      <div className="flex h-full flex-col gap-4">
        {isBnplFeatureEnabled &&
          Boolean(isEligible) &&
          (isBnpl || showPayLater) &&
          payLaterPrice && (
            <div className="flex items-center justify-between">
              <span className="text-sm font-semibold text-text-primary">
                {t("payment.payLaterPerMonth")}
              </span>
              <span dir="ltr" className="text-md font-semibold">
                {payLaterPrice}
              </span>
            </div>
          )}
        {totalPrice ? (
          <div className="flex items-center justify-between">
            <h5 className="text-sm font-semibold text-text-primary">
              {t("payment.standard")}
            </h5>

            <span dir="ltr" className="text-md font-semibold">
              {totalPrice}
            </span>
          </div>
        ) : null}

        <Button
          fullWidth
          variant="contained"
          onClick={onButtonClick}
          disabled={disabled}
          loading={loading}
        >
          {buttonLabel}
        </Button>
      </div>
    </PersistentDrawer>
  );
};

export default BottomDrawer;
